import { Directive } from '@angular/core';

@Directive({
  selector: '[rxAutocompleteLabel]',
})
export class RxAutocompleteLabelDirective {
  constructor() {}
}
